
import React from 'react';
import { motion } from 'framer-motion';
import './PhilosophyComponent.css';

const PhilosophyComponent: React.FC = () => {
  return (
      <motion.div
          className="philosophy-bridge"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.2,
            ease: [0.25, 0.1, 0.25, 1]
          }}
          viewport={{ once: true }}
      >
        <div className="philosophy-glass-container">
          <div className="philosophy-backdrop"></div>
          <div className="philosophy-glow"></div>

          <div className="philosophy-content">
            <motion.blockquote
                className="philosophy-quote"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
            >
              "Modern tools <span className="emphasis-fracture">shatter</span> your focus.
              Augments <span className="emphasis-rebuild">rebuilds</span> your mind."
            </motion.blockquote>

            <motion.div
                className="philosophy-text-flow"
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                viewport={{ once: true }}
            >
              <div className="philosophy-paragraph opening-paragraph">
                In a world overwhelmed by <span className="text-italic">noise and endless tabs</span>, Augments offers your
                <strong className="text-bold-italic"> Mental OS</strong>. A sanctuary where thoughts
                <span className="flow-words"> breathe, evolve, and connect</span>.
                We keep your <span className="text-bold">documents, research, and decisions</span> seamlessly connected through
                AI-powered links.
              </div>

              <div className="philosophy-paragraph philosophy-core">
                Your mind deserves a space that honors how ideas truly form:
                <em className="text-italic"> fluid, connected, and alive</em>.

                Not just another tool, but a <em className="partner-emphasis">partner in thought</em>,
                designed to <span className="text-bold">amplify</span> clarity and creativity.
              </div>

              <div className="philosophy-paragraph values-paragraph">
                Born from <span className="text-bold">European</span> values of
                <span className="values-trilogy"> privacy, respect, and intellectual freedom</span>,
                Augments helps you transcend distraction and superficial noise, creating
                a new standard for <span className="text-italic">thoughtful digital work</span>.
              </div>

              <div className="philosophy-paragraph closing-paragraph">
                This is where your work meets your mind, elegantly connected through our
                revolutionary <strong className="text-bold-italic">Tiles & Bridges</strong> philosophy
                <span className="natural-flow">, mirroring the natural flow of your thinking</span>.
              </div>
            </motion.div>

            <motion.div
                className="philosophy-connector"
                initial={{ scaleY: 0 }}
                whileInView={{ scaleY: 1 }}
                transition={{ duration: 1.4, delay: 1.0, ease: [0.25, 0.1, 0.25, 1] }}
                viewport={{ once: true }}
            />
          </div>
        </div>
      </motion.div>
  );
};

export default PhilosophyComponent;